// -----------------------------------------------------------
// FloraIQ — Aba RRR e Autorizações
// -----------------------------------------------------------

import { rrrInconsistencies } from "@/mocks/quality";
import { ValidationStatusBadge } from "./QualityStatusBadge";

export default function RrrAuthorizationValidationPanel() {
  const criticos = rrrInconsistencies.filter((r) => r.status === "crítico").length;
  const vencidos = rrrInconsistencies.filter((r) => r.status === "vencido").length;
  const pendentes = rrrInconsistencies.filter((r) => r.status === "pendente").length;

  return (
    <div className="space-y-6">
      {/* Cards resumo */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {[
          { label: "Supressões sem Autorização", value: rrrInconsistencies.filter((r) => r.tipo === "Supressão").length, icon: "ri-scissors-line", color: "red" },
          { label: "Intervenções sem Responsável", value: rrrInconsistencies.filter((r) => r.tipo === "Intervenção").length, icon: "ri-user-unfollow-line", color: "red" },
          { label: "Obrigações Vencidas", value: vencidos, icon: "ri-calendar-close-line", color: "red" },
          { label: "Restrições sem Fonte", value: rrrInconsistencies.filter((r) => r.tipo === "Restrição").length, icon: "ri-shield-cross-line", color: "orange" },
          { label: "Compensações sem Evidência", value: rrrInconsistencies.filter((r) => r.tipo === "Compensação" || r.tipo === "Obrigação").length, icon: "ri-scales-line", color: "yellow" },
          { label: "Espécies Protegidas sem RRR", value: 21, icon: "ri-plant-line", color: "orange" },
        ].map((p) => (
          <div key={p.label} className="bg-white rounded-card border border-background-200/70 p-3">
            <div className="flex items-center gap-2 mb-1">
              <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${
                p.color === "red" ? "bg-red-100 text-red-600" : p.color === "orange" ? "bg-orange-100 text-orange-600" : "bg-yellow-100 text-yellow-600"
              }`}>
                <i className={`${p.icon} text-xs`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-600 truncate">{p.label}</span>
            </div>
            <p className="text-lg font-bold font-heading text-foreground-900">{p.value}</p>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Tipo</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Unidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Parte Responsável</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Documento Fonte</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Problema</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Prazo</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Status</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600">Ações</th>
            </tr>
          </thead>
          <tbody>
            {rrrInconsistencies.map((r) => (
              <tr key={r.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5 font-medium text-foreground-700">{r.tipo}</td>
                <td className="px-3 py-2.5 font-mono text-foreground-700 max-w-[140px] truncate">{r.unidade}</td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[140px] truncate">{r.parteResponsavel}</td>
                <td className="px-3 py-2.5 text-foreground-500 max-w-[120px] truncate">{r.documentoFonte}</td>
                <td className="px-3 py-2.5 text-foreground-700 max-w-[240px] truncate">{r.problema}</td>
                <td className="px-3 py-2.5 text-foreground-600">{r.prazo}</td>
                <td className="px-3 py-2.5"><ValidationStatusBadge status={r.status} /></td>
                <td className="px-3 py-2.5 text-center">
                  <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Corrigir">
                    <i className="ri-tools-line text-foreground-500 text-sm"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}